import { FlatbondApiBase } from './base';

export class FlatbondExtendApi extends FlatbondApiBase {
  create(flatbondId, data) {
    return super.post(`${flatbondId}/extend/`, data, 'Unable to extend flatbond.');
  }
}
